<template>
    <div v-show="visible">
        <el-dialog title="查看人脸视频" :visible.sync="visible" :close-on-click-modal="false" 
            v-loading="loading"
            :before-close="dialogClose"  width="400px">    
            <el-form ref="form" label-width="70px">
                
                <el-upload
                    v-if="!showVideo"
                    class="upload-demo"
                    action=""
                    :show-file-list="false"
                    :auto-upload="true"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <el-button size="small" type="primary">点击导入人脸视频</el-button>&nbsp;&nbsp;
                    <div slot="tip" class="el-upload__tip" style="font-size:12px;color:#BBBBBB">
                        &nbsp;&nbsp;&nbsp;&nbsp;点击“查看视频模板”按钮，查看视频演示根据模板演示方式拍摄视频，然后再导入到平台。
                    </div>
                </el-upload>

                <el-form-item label="人脸视频" v-if="showVideo">
                    <el-button type="success" @click="lookVieo()">查看视频</el-button>
                    <el-button type="danger" @click="showVideo=false">删除视频</el-button>
                </el-form-item>

                <el-button size="small" type="info" @click="lookTemplate()" v-if="!showVideo">查看视频模板</el-button>    
            </el-form>
        </el-dialog>

        <!--查看人脸视频模板 -->
        <div v-if="lookVideoVisible">
            <lookVideo ref="lookVideo"></lookVideo>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import lookVideo from './Video.vue';

    export default {
        data(){
            return{
                visible: false,
                loading: false,
                lookVideoVisible: false,
                userId:"",
                videoUrl: "",
                showVideo:false
            }
        },
        components: {
            lookVideo
        },
        created:function () {
        },
        methods:{
             init(userId){
                this.visible = true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.userId=userId;
                this.showVideo=false;

                // 获取视频数据
                this.getVideoInfo();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getVideoInfo(){ // 获取视频信息
                let url  = this.userFileListUrl;
                let data = {
                    userId:this.userId                
                };
                
                this.apiPost(url,data).then((res) => {
                    // console.log(res.data);
                    if(res.status==200){
                        if(res.data.userFile.fileUrl!='' && res.data.userFile.fileUrl!=null){
                            this.videoUrl=res.data.userFile.fileUrl;
                            this.showVideo=true;
                            console.log(this.videoUrl);
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            handleAvatarSuccess(res, file) {
                //this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                var fileSize = file.size / 1024 / 1024 < 50;
                if (['video/mp4'].indexOf(file.type) == -1) {
                    this.$commonFn.showTip('请上传正确的视频格式', 3);
                    return;
                }
                if (!fileSize) {
                    this.$commonFn.showTip('视频大小不能超过50MB', 3);
                    return;
                }
                // 上传文件
                this.loading=true;
                let uploadForm=new FormData();
                uploadForm.append('file', file);
                uploadForm.append('userId', this.userId);
                this.$axios.post(this.userFileSaveUrl, uploadForm).then((res) => {
                    // console.log("文件反馈:"+JSON.stringify(res.data))
                    if(res.data.status == 200){
                        // this.$commonFn.showTip(res.data.message, 4,true);
                        // this.visible=false;
                        this.$commonFn.showTip(res.data.message,1);
                        this.visible=false;
                        this.$parent.getData();
                    }else{
                        this.$commonFn.showTip(res.data.message, 3);
                    }
                    this.loading=false;
                }, (err) => {
                    this.loading=false;
                    console.log(err)
                    this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3);
                });
            },
            // 查看视频
            lookVieo(){
                this.lookVideoVisible=true;
                this.$nextTick(() => {
                    this.$refs['lookVideo'].init(this.videoUrl);
                })
            },
            // 查看模板
            lookTemplate(){
                this.lookVideoVisible=true;
                this.$nextTick(() => {
                    this.$refs['lookVideo'].init('../../../../static/video.mp4');
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/page/sys/user/UploadVideo.vue